// Generated by scripts/gen_execution_approval_types.py; do not edit.
import { z } from 'zod'

export const QuotedNodeSchema = z.object({
  "node_id": z.string(),
  "type": z.string(),
  "label": z.string(),
  "sparks_estimated": z.number().int().min(0),
  "action": z.union([z.string(), z.null()]).default(null),
  "output_count": z.number().int().min(1).default(1),
  "edit_spec_version": z.union([z.number().int(), z.null()]).default(null),
  "edit_spec_fingerprint": z.union([z.string(), z.null()]).default(null),
  "render_contract_version": z.union([z.number().int(), z.null()]).default(null)
}).strict()
export type QuotedNode = z.infer<typeof QuotedNodeSchema>

export const ApprovalCardSchema = z.object({
  "approval_id": z.string().min(1),
  "quote_version": z.number().int().min(1),
  "quote_hash": z.string().min(1),
  "billing_mode": z.enum(["paid", "free_trial"]).default("paid"),
  "maximum_spend": z.number().int().min(0),
  "status": z.enum(["pending", "approved", "rejected"]),
  "nodes": z.array(QuotedNodeSchema)
}).strict()
export type ApprovalCard = z.infer<typeof ApprovalCardSchema>

export const ExecutionSummarySchema = z.object({
  "id": z.string(),
  "batch_id": z.string(),
  "node_id": z.string(),
  "status": z.enum(["waiting_approval", "waiting_dependencies", "dispatch_pending", "dispatching", "queued", "running", "succeeded", "failed", "rejected"]),
  "blocker": z.union([z.string(), z.null()])
}).strict()
export type ExecutionSummary = z.infer<typeof ExecutionSummarySchema>

export const ApprovalSnapshotSchema = z.object({
  "approvals": z.array(ApprovalCardSchema),
  "executions": z.array(ExecutionSummarySchema)
}).strict()
export type ApprovalSnapshot = z.infer<typeof ApprovalSnapshotSchema>

export const ApprovalRefSchema = z.object({
  "approval_id": z.string().min(1),
  "quote_version": z.number().int().min(1),
  "quote_hash": z.string().min(1)
}).strict()
export type ApprovalRef = z.infer<typeof ApprovalRefSchema>

export const ConfirmApprovalsRequestSchema = z.object({
  "requests": z.array(ApprovalRefSchema).min(1).max(100)
}).strict()
export type ConfirmApprovalsRequest = z.infer<typeof ConfirmApprovalsRequestSchema>

export const RerunNodeContextSchema = z.object({
  "node_id": z.string(),
  "display_action": z.union([z.literal("rerun"), z.null()]).default(null),
  "tracked_attempt": z.union([z.number().int().min(1), z.null()]).default(null),
  "earlier_runs_untracked": z.boolean().default(false),
  "task_owner": z.union([z.enum(["User", "Director"]), z.null()]).default(null),
  "director_reason": z.union([z.string(), z.null()]).default(null),
  "comparison_available": z.boolean(),
  "changed_fields": z.array(z.enum(["motion_prompt", "prompt", "reference_images", "model", "duration", "reference_connections", "other_settings"])),
  "upstream_reference_uncertain": z.boolean().default(false),
  "prior_spent_sparks": z.union([z.number().int().min(0), z.null()]).default(null),
  "prior_reserved_sparks": z.union([z.number().int().min(0), z.null()]).default(null)
}).strict()
export type RerunNodeContext = z.infer<typeof RerunNodeContextSchema>

export const ApprovalRerunContextSchema = z.object({
  "approval_id": z.string(),
  "quote_hash": z.string(),
  "nodes": z.array(RerunNodeContextSchema)
}).strict()
export type ApprovalRerunContext = z.infer<typeof ApprovalRerunContextSchema>
